<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>充值记录</el-breadcrumb-item>
          <el-breadcrumb-item>用户充值记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="5" class="display-row">
            <div class="query-title">创建开始日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">创建结束日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title" style="text-align:right">充值流水号:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.rechargeNo"
                  size="small"
                  @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title" style="text-align:right">客户ID:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.customerName"
                  size="small"
                  @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
            :data="recordList"
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            border
            height="550"
        >
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column label="订单操作" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row" v-if="['0' ].indexOf(scope.row.rechargeStatus) > -1 ">
                <el-button
                    @click="acceptAction(scope.row)"
                    class="list-btn btn-blue"
                >通过
                </el-button>
              </div>
              <div class="btn-row" v-if="['0' ].indexOf(scope.row.rechargeStatus) > -1 ">
                <el-button
                    @click="sendAction(scope.row)"
                    class="list-btn btn-warn"
                >驳回
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="customerName"
              label="客户ID">
          </el-table-column>
          <el-table-column
              prop="drawee"
              label="付款人">
          </el-table-column>
          <el-table-column
              prop="createTime"
              sortable
              :index="indexMethod"
              width="100"
              align="center"
              label="创建时间">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column
              prop="tradingNo"
              width="120"
              label="交易编号">
            </el-table-column>
          <el-table-column
              prop="rechargeNo"
              align="center"
              width="120"
              label="充值流水编号">
          </el-table-column>
          <el-table-column
              prop="bankNo"
              width="120"

              label="付款账号">
          </el-table-column>
          <el-table-column
              prop="orderNum"
              width="120"
              align="center"
              label="交易订单号">
          </el-table-column>
          <el-table-column
              prop="money"
              :index="indexMethod"
              sortable
              width="140"
              align="center"
              label="到账金额（元）">
          </el-table-column>
          <el-table-column
            prop="paypalFeeJpy"
            :index="indexMethod"
            sortable
            width="170"
            align="center"
            label="PayPal手续费（円）">
          </el-table-column>
          <el-table-column
              prop="moneyJpy"
              :index="indexMethod"
              sortable
              width="150"
              align="center"
              label="充值金额（日元）">
          </el-table-column>
          <el-table-column
              prop="exchangeRate"
              align="center"
              label="汇率">
          </el-table-column>
          <el-table-column
              prop="rechargeType"
              :index="indexMethod"
              sortable
              width="120"
              align="center"
              label="充值方式">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.rechargeType) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="payTime"
              sortable
              :index="indexMethod"
              align="center"
              width="120"
              label="汇款日期">
            <template v-slot="scope">
              {{ scope.row.payTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column
              prop="rechargeStatus"
              :index="indexMethod"
              sortable
              width="120"
              align="center"
              label="充值状态">
            <template v-slot="scope">
              {{ rechargeStatusShow(scope.row.rechargeStatus) }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: {tableCon},
  data() {
    return {
      queryInfo: {
        rechargeNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        customerName: '',
        pageSize: 10,
        pageNum: 1
      },
      orderDateRangeValue: [],
      recordList: [],
      total: 0,
      orderDetailValue: {
        id: '',
        rechargeStatus: ''
      },
    }
  },
  methods: {
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    //正常发送
    sendAction(row) {
      this.sendDeal(row)
    },
    acceptAction(row) {
      this.acceptDeal(row)
    },

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    orderDateRange() {

    },
    searchList() {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    toRechargeMoney(row) {
      console.log(row);
      this.$router.push({
        name: 'recharge',
        query: {
          id: row.id
        }
      })
    },
    async getrecordList() {
      this.$set(this.queryInfo, "allSigns", "allSigns")
      const {data: res} = await this.$http.get('/payRecord/list', {params: this.queryInfo});
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    acceptDeal(row) {
      this.$confirm("确定通过审核本次充值记录吗", "", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        this.orderDetailValue.id = row.id;
        this.orderDetailValue.rechargeStatus = '1';
        const {data: res} = await this.$http.post(`payRecord/updateAction/`, this.orderDetailValue);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          await this.getrecordList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消修改"
        });
      });
    },
    sendDeal(row) {
      this.$confirm("确定驳回本次充值记录吗", "", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        this.orderDetailValue.id = row.id;
        this.orderDetailValue.rechargeStatus = '2';
        const {data: res} = await this.$http.post(`payRecord/updateAction/`, this.orderDetailValue);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          await this.getrecordList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消修改"
        });
      });
    },
    queryInfoClear() {    //清空
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        rechargeNo: '',
        customerName: '',
        pageSize: 10,
        pageNum: 1
      }
      this.orderDateRangeValue = [];
    },
    rechargeStatusShow(status) {
      switch (status) {
        case '0':
          return '审核中'
          break;
        case '1':
          return '充值成功'
          break;
        case '2':
          return '充值失败'
          break;
        case '3':
          return '用户已取消'
          break;
      }
    }, typeDetailShow(status) {
      switch (status) {
        case '0':
          return '微信'
          break;
        case '1':
          return '支付宝'
          break;
        case '2':
          return '银行转账'
          break;
        case '3':
          return 'PayPal 结算'
          break;
        case '4':
          return 'AliPay 结算'
          break;
      }
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    orderDateRangeValue() {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.orderDateRangeValue) {
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.orderDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      }

    }
  },
  created() {
    this.getrecordList();
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
